// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import RequestSummaryItemSchema from './request-summary-item-schema';

const schema = {
  $id: '/request-summary-section-schema',
  type: 'object',
  required: [],
  nullable: true,
  properties: {
    title: {
      type: 'string',
      nullable: true,
    },
    items: {
      type: 'array',
      nullable: true,
      items: { ...RequestSummaryItemSchema },
    },
  },
} as IJSONSchema;

export default schema;
